var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import deleteOrganisationInvite from '../../requests/organisation/deleteOrganisationInvite';
import Signals from '../../signals/Signals';
/**
 *
 */
var DeleteInviteOrganisationUserCommand = /** @class */ (function (_super) {
    __extends(DeleteInviteOrganisationUserCommand, _super);
    function DeleteInviteOrganisationUserCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param organisation OrganisationModel
     * @param invite InviteModel
     * @param inviteCollection InviteCollection
     * @param intl
     * @return {*}
     */
    DeleteInviteOrganisationUserCommand.prototype.execute = function (organisation, invite, inviteCollection, intl) {
        this.organisation = organisation;
        this.invite = invite;
        this.inviteCollection = inviteCollection;
        this.intl = intl;
        var promise = deleteOrganisationInvite(organisation.id, invite.inviteeEmail);
        promise.then(this.then);
        promise.catch(this.catch);
        return promise;
    };
    /**
     *
     * @param response
     */
    DeleteInviteOrganisationUserCommand.prototype.then = function (response) {
        this.inviteCollection.remove(this.invite);
        Signals.ShowNotification.dispatch(this.intl.formatMessage({ id: 'notification.userinvitation.deleted' }, Object(this.invite)), 'dark', true);
    };
    return DeleteInviteOrganisationUserCommand;
}(Command));
export default DeleteInviteOrganisationUserCommand;
